<template>
    <nav>
        <ul class="pagination justify-content-center m-0">
            <li class="page-item" v-bind:class="{ active: button.number == currentPage }" v-for="button in buttons">
                <button v-if="button.number" type="button" class="page-link" v-on:click="goToPage(button.number)">{{ button.number }}</button>
                <span v-if="button.isSpacer" class="page-link page-spacer">...</span>
            </li>
        </ul>
        <div class="page-input">
            <input
                type="number"
                v-model.number="inputPage"
                :min="1"
                :max="pageCount"
                class="form-control"
                @keyup.enter="submitPage"
            />
            <button class="btn btn-primary" @click="submitPage">&raquo;</button>
        </div>
    </nav>
</template>

<script>
    function makeButtons(currentPage, pageCount) {
        const maxButtonCount = 9;
        const buttons = [];
        const middle = Math.ceil(maxButtonCount / 2);
        if (pageCount <= maxButtonCount) {
            // 1 2 3 4 5 6 7
            for (let i = 1; i <= pageCount; i++) {
                buttons.push({ number: i });
            }
        } else if (currentPage <= middle) {
            // 1 2 3 4 5 ... 8
            const to = maxButtonCount - 2;
            for (let i = 1; i <= to; i++) {
                buttons.push({ number: i });
            }
            buttons.push({ isSpacer: true });
            buttons.push({ number: pageCount });
        } else if (currentPage >= pageCount - (maxButtonCount - middle)) {
            // 1 ... 4 5 6 7 8
            buttons.push({ number: 1 });
            buttons.push({ isSpacer: true });
            const from = pageCount - maxButtonCount + 3;
            for (let i = from; i <= pageCount; i++) {
                buttons.push({ number: i });
            }
        } else {
            // 1 ... 4 5 6 ... 9
            buttons.push({ number: 1 });
            buttons.push({ isSpacer: true });
            const from = currentPage - middle + 3;
            const to = from + (maxButtonCount - 4);
            for (let i = from; i <= to; i++) {
                buttons.push({ number: i });
            }
            buttons.push({ isSpacer: true });
            buttons.push({ number: pageCount });
        }
        return buttons;
    }

    export default {
        name: 'PageNav',
        props: {
            currentPage: Number,
            pageCount: Number
        },
        data() {
            return {
                buttons: [],
                inputPage: "" // изначально текущая страница
            };
        },
        methods: {
            goToPage(pageNum) {
                this.$emit('change', pageNum);
                document.activeElement.blur();
            },
            submitPage() {
                if(this.inputPage == "")
                    return;

                let page = Number(this.inputPage);
                if (!page || page < 1) page = 1;
                else if (page > this.pageCount) page = this.pageCount;
                if (page !== this.currentPage) {
                    this.goToPage(page);
                }
                // синхронизируем поле с текущей страницей
                this.inputPage = "";//page;
                document.activeElement.blur();
            }
        },
        watch: {
            currentPage: function (newValue/*, oldValue*/) {
                this.buttons = makeButtons(newValue, this.pageCount);
            },
            pageCount: function (newValue/*, oldValue*/) {
                this.buttons = makeButtons(this.currentPage, newValue);
            }
        },
        created() {
            this.buttons = makeButtons(this.currentPage, this.pageCount);
        }
    };
</script>

<style lang="scss" scoped>
nav {
    display: flex;
    gap: 10px;
    align-items: baseline;
    justify-content: center;
}
.page-input {
    display: flex;
}
.page-input input {
    max-width: 55px;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    border-radius: 0.25rem 0 0 0.25rem;
}
.page-input button {
    border-radius: 0 0.25rem 0.25rem 0;
}
</style>